import * as React from 'react';
import { ButtonBaseProps } from '../../ButtonBase/ButtonBase';
import { Styler, StylerProps } from '../../Styler/Styler';
import { useAccordionContext } from '../Accordion.context';
import { useStyles } from './AccordionHeader.styles';

export interface AccordionHeaderProps extends StylerProps, ButtonBaseProps {
    /**
     * The content of the component.
     */
    children: React.ReactNode;
}

export function AccordionHeader(props: Readonly<AccordionHeaderProps>): React.JSX.Element {
    const { children, onClick, LabelProps, icon, ref, ...other } = props;

    const { headerId, contentId, expanded, onToggle, chevron } = useAccordionContext();

    const { styles } = useStyles();

    const handleClick = (event: React.SyntheticEvent): void => {
        onClick?.(event);
        onToggle?.(event);
    };

    return (
        <Styler
            ref={ref}
            button={true}
            component="div"
            baseStyles={styles.root}
            onClick={handleClick}
            aria-expanded={expanded}
            aria-controls={contentId}
            id={headerId}
            data-accordion-header={true}
            {...other}
        >
            <div css={styles.label}>{children}</div>

            {chevron &&
                React.cloneElement(chevron, {
                    css: styles.chevron,
                    'data-rotate': expanded || undefined,
                })}
        </Styler>
    );
}
